export enum WidgetActionEnum {
  NAVIGATE = 'navigate',
  ADDTOCART = 'addToCart',
}

export enum ImageScaling {
  CROP = 'crop',
  FIT = 'fit',
}

export enum WidgetDirectionEnum {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum WidgetAlignmentEnum {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum WidgetPresetIdEnum {
  VERTICAL = 'Wix_Store_Product_Widget_Vertical',
  HORIZONTAL = 'Wix_Store_Product_Widget_Horizontal',
}

export enum WidgetAreaEnum {
  CONTENT = 'content',
  VISUAL = 'visual',
  ALL = 'all',
}
